import React from 'react';
var defaultLocaleContext = {
  locale: '',
  localeOnChangeCallback: undefined,
  dateLocale: {}
};
var LocaleContext = React.createContext(defaultLocaleContext);
export var LocaleContextProvider = LocaleContext.Provider;
export var LocaleContextConsumer = LocaleContext.Consumer;
export default LocaleContext;